import { render, staticRenderFns } from "./BlocoListarAtivasCertificao.vue?vue&type=template&id=3af1a1d8&scoped=true"
import script from "./BlocoListarAtivasCertificao.vue?vue&type=script&lang=js"
export * from "./BlocoListarAtivasCertificao.vue?vue&type=script&lang=js"
import style0 from "./BlocoListarAtivasCertificao.vue?vue&type=style&index=0&id=3af1a1d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af1a1d8",
  null
  
)

export default component.exports